import React from 'react'
import Table from '../../widgets/Table'
import { selectChurnedCustomers } from './reports.selectors'
import { useSelector } from 'react-redux'
import SortingCustomIcon from '../../widgets/SortingCustomIcon'
import { REGIONS } from '../../widgets/busyIndicator'
import { getDateAndTimeFormatter } from '../../widgets/CustomDateRangePicker/CustomDateRangePicker.utils'
import {
	getFormattedTitle,
	getFormattedAccountName,
} from '../Reports/reports.constants'
import DashboardCard from '../../components/cards/DashboardCard'

const ChurnedCustomers = () => {
	const churnedCustomers = useSelector(selectChurnedCustomers)
	const columns = [
		{
			dataField: 'name',
			text: 'Account',
			sort: true,
			title: getFormattedTitle,
			formatter: getFormattedAccountName,
			sortCaret: SortingCustomIcon,
		},
		{
			dataField: 'churnedDate',
			text: 'Churn Date',
			sort: true,
			sortCaret: SortingCustomIcon,
			formatter: getDateAndTimeFormatter,
		},
		{
			dataField: 'churnedReason',
			text: 'Churn Reason',
			sort: true,
			sortCaret: SortingCustomIcon,
		},
	]

	return (
		<DashboardCard title='Churned Customers'>
			<div className='overflow-y-auto max-h-[415px]'>
				<Table
					keyField='id'	
					columns={columns}
					data={churnedCustomers}
					region={REGIONS.FETCH_CHURNED_CUSTOMERS}
					isDisplayTable={true}
				/>
			</div>
		</DashboardCard>
	)
}

export default ChurnedCustomers
